var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { row: "" } },
    [
      _c(
        "v-dialog",
        {
          attrs: {
            persistent: "",
            fullscreen: "",
            "hide-overlay": "",
            transition: "dialog-bottom-transition"
          },
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-toolbar",
                { attrs: { dark: "", color: "primary", fixed: "" } },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", dark: "" },
                      on: {
                        click: function($event) {
                          return _vm.handleClosed()
                        }
                      }
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  ),
                  _c("v-toolbar-title", [
                    _vm._v(
                      "Detalle de Nota de Venta de\n          " +
                        _vm._s(_vm.localData["Nombre NDV"])
                    )
                  ]),
                  _c("v-spacer")
                ],
                1
              ),
              _c("br"),
              _c("br"),
              _c("br"),
              _c("div", [
                _c(
                  "div",
                  { staticClass: "cardnew", attrs: { align: "center" } },
                  [
                    _c("br"),
                    _c(
                      "v-flex",
                      { attrs: { md10: "" } },
                      [
                        _c(
                          "v-card",
                          {
                            staticClass: "rounded-card",
                            attrs: { align: "left" }
                          },
                          [
                            _c(
                              "v-container",
                              { attrs: { "grid-list-md": "" } },
                              [
                                _vm.validaAtencion()
                                  ? _c("h2", { staticClass: "h2_title mb-1" }, [
                                      _vm._v(
                                        "\n                  Generar Atención\n                "
                                      )
                                    ])
                                  : _vm._e(),
                                _vm.validaFacturacionEspecial()
                                  ? _c("h2", { staticClass: "h2_title mb-1" }, [
                                      _vm._v(
                                        "\n                  Generar Facturación Especial\n                "
                                      )
                                    ])
                                  : _vm._e(),
                                _c("v-divider"),
                                _c(
                                  "v-flex",
                                  {
                                    attrs: {
                                      xs12: "",
                                      sm12: "",
                                      md12: "",
                                      layout: "",
                                      wrap: ""
                                    }
                                  },
                                  [
                                    _vm.validaFacturacionEspecial()
                                      ? _c(
                                          "v-flex",
                                          {
                                            attrs: {
                                              layout: "",
                                              wrap: "",
                                              xs12: "",
                                              sm4: "",
                                              md4: ""
                                            }
                                          },
                                          [
                                            _c("v-text-field", {
                                              attrs: {
                                                label: "Numero Factura INET",
                                                "item-text": "ndvnombre",
                                                "item-value": "ndvnombre",
                                                clearable: "",
                                                "prepend-icon": "receipt"
                                              },
                                              model: {
                                                value: _vm.nro_factura,
                                                callback: function($$v) {
                                                  _vm.nro_factura = $$v
                                                },
                                                expression: "nro_factura"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm.validaAtencion()
                                      ? _c(
                                          "v-flex",
                                          { attrs: { layout: "", wrap: "" } },
                                          [
                                            _c(
                                              "v-flex",
                                              {
                                                attrs: {
                                                  xs12: "",
                                                  sm12: "",
                                                  md12: ""
                                                }
                                              },
                                              [
                                                _c(
                                                  "v-radio-group",
                                                  {
                                                    attrs: {
                                                      label:
                                                        "Tipo de Documento : ",
                                                      row: ""
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.atencion
                                                          .tipoDocumento,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.atencion,
                                                          "tipoDocumento",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "atencion.tipoDocumento"
                                                    }
                                                  },
                                                  [
                                                    _c("v-radio", {
                                                      attrs: {
                                                        label:
                                                          "910 - Guia Control Interno",
                                                        value: 910
                                                      }
                                                    }),
                                                    _c("v-radio", {
                                                      attrs: {
                                                        label:
                                                          "915 - Guia de Arriendo",
                                                        value: 915
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ],
                                              1
                                            ),
                                            _c(
                                              "v-flex",
                                              {
                                                attrs: {
                                                  xs12: "",
                                                  sm4: "",
                                                  md4: ""
                                                }
                                              },
                                              [
                                                _c("v-text-field", {
                                                  attrs: {
                                                    label: "Divisa de NDV",
                                                    disabled: "",
                                                    "prepend-icon": "payments"
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.atencion.divisaNDV,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.atencion,
                                                        "divisaNDV",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "atencion.divisaNDV"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _c(
                                              "v-flex",
                                              {
                                                attrs: {
                                                  xs12: "",
                                                  sm4: "",
                                                  md4: ""
                                                }
                                              },
                                              [
                                                _c("v-text-field", {
                                                  attrs: {
                                                    label:
                                                      "Divisa de la Atención",
                                                    disabled: "",
                                                    "prepend-icon": "payments"
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.atencion
                                                        .divisaAtencion,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.atencion,
                                                        "divisaAtencion",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "atencion.divisaAtencion"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _c(
                                              "v-flex",
                                              {
                                                attrs: {
                                                  xs12: "",
                                                  sm4: "",
                                                  md4: ""
                                                }
                                              },
                                              [
                                                _c("v-text-field", {
                                                  attrs: {
                                                    label: "Tipo de Cambio",
                                                    "prepend-icon":
                                                      "currency_exchange"
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.atencion.tipoCambio,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.atencion,
                                                        "tipoCambio",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "atencion.tipoCambio"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _c(
                                              "v-flex",
                                              {
                                                attrs: {
                                                  xs12: "",
                                                  sm4: "",
                                                  md4: ""
                                                }
                                              },
                                              [
                                                _c("v-text-field", {
                                                  attrs: {
                                                    label: "Orden de Compra",
                                                    clearable: "",
                                                    "prepend-icon": "receipt"
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.atencion.ordenCompra,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.atencion,
                                                        "ordenCompra",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "atencion.ordenCompra"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _c(
                                              "v-flex",
                                              {
                                                attrs: {
                                                  xs12: "",
                                                  sm4: "",
                                                  md4: ""
                                                }
                                              },
                                              [
                                                _c("DatePicker", {
                                                  attrs: {
                                                    label:
                                                      "Fecha valor Tipo de Cambio",
                                                    "prepend-icon":
                                                      "calendar_month",
                                                    max: _vm.fecha_maxima
                                                  },
                                                  model: {
                                                    value: _vm.atencion.fecha,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.atencion,
                                                        "fecha",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "atencion.fecha"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _c(
                                              "v-flex",
                                              {
                                                attrs: {
                                                  xs12: "",
                                                  sm4: "",
                                                  md4: ""
                                                }
                                              },
                                              [
                                                _c("v-textarea", {
                                                  attrs: {
                                                    label: "Observaciones",
                                                    clearable: "",
                                                    rows: "1",
                                                    "auto-grow": "",
                                                    "prepend-icon": "comment"
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.atencion
                                                        .observaciones,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.atencion,
                                                        "observaciones",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "atencion.observaciones"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "v-card",
                          {
                            staticClass: "rounded-card mt-4",
                            attrs: { align: "left" }
                          },
                          [
                            _c(
                              "v-container",
                              { attrs: { "grid-list-md": "" } },
                              [
                                _c(
                                  "v-flex",
                                  { attrs: { xs12: "", sm12: "", md12: "" } },
                                  [
                                    _c(
                                      "v-flex",
                                      {
                                        attrs: {
                                          xs12: "",
                                          sm6: "",
                                          md6: "",
                                          lg4: "",
                                          "mt-4": ""
                                        }
                                      },
                                      [
                                        _c("v-text-field", {
                                          attrs: {
                                            label: "Buscar...",
                                            "append-icon": "search"
                                          },
                                          on: { input: _vm.handleSearch },
                                          model: {
                                            value: _vm.quickSearch,
                                            callback: function($$v) {
                                              _vm.quickSearch = $$v
                                            },
                                            expression: "quickSearch"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { attrs: { align: "left" } },
                                      [
                                        _c("GridComponent", {
                                          staticClass: "ag-theme-material",
                                          attrs: {
                                            "grid-options": _vm.gridOptions
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c("br")
                                  ],
                                  1
                                ),
                                _c(
                                  "v-flex",
                                  { attrs: { xs12: "", sm12: "", md12: "" } },
                                  [
                                    _c(
                                      "v-flex",
                                      {
                                        staticStyle: { "text-align": "end" },
                                        attrs: { xs4: "", sm12: "", md12: "" }
                                      },
                                      [
                                        _c(
                                          "v-btn",
                                          {
                                            staticClass:
                                              "btn-volver white--text",
                                            on: { click: _vm.handleCancel }
                                          },
                                          [_vm._v("Cancelar")]
                                        ),
                                        _c(
                                          "v-btn",
                                          {
                                            staticClass:
                                              "btn-grabar white--text",
                                            on: { click: _vm.showAlerta }
                                          },
                                          [_vm._v("Confirmar")]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]),
              _c(
                "Confirmation",
                {
                  attrs: {
                    show: _vm.dialogPopUp,
                    titulo: _vm.contextPopUp.title,
                    mensaje: _vm.contextPopUp.msg,
                    textoBtnSi: _vm.$t(_vm.contextPopUp.btnConfirmation),
                    textoBtnNo: _vm.$t("Cancelar")
                  },
                  on: {
                    modalConfirmationEmit: function($event) {
                      return _vm.handleShowPopUp($event)
                    }
                  }
                },
                [
                  _vm.mostrarHijo
                    ? _c(
                        "v-flex",
                        {
                          staticStyle: { padding: "16px" },
                          attrs: { xs12: "" }
                        },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "", sm12: "", md12: "" } },
                            [
                              _c("v-textarea", {
                                attrs: {
                                  label: "Observaciones",
                                  clearable: ""
                                },
                                model: {
                                  value: _vm.atencion.observaciones,
                                  callback: function($$v) {
                                    _vm.$set(_vm.atencion, "observaciones", $$v)
                                  },
                                  expression: "atencion.observaciones"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _c(
                "ModalInformativo",
                {
                  attrs: {
                    show: _vm.modal_errores,
                    titulo: "Respuesta Integración INET",
                    width: "700"
                  },
                  on: { modalInformativo: _vm.handleModalInformativo }
                },
                [
                  _vm.lista_errores
                    ? _c(
                        "ul",
                        _vm._l(
                          _vm.lista_errores.RespuestaProceso.Errores,
                          function(error, index) {
                            return _c("li", { key: index }, [
                              _vm._v(
                                "\n            " +
                                  _vm._s(error.ErrorDescripcion) +
                                  "\n          "
                              )
                            ])
                          }
                        ),
                        0
                      )
                    : _vm._e()
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }